import { Configuration, ResponseError } from "../../../generated/api-client/runtime";

const endpoint = import.meta.env.VITE_API_ENDPOINT?.replace(/\/+$/, "") || "/api";

/** Shared generated transport configuration. Session authentication remains cookie based. */
export const generatedConfiguration = new Configuration({
    basePath: endpoint,
    credentials: "include",
    headers: { Accept: "application/json" }
});

export { ResponseError };
